// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"6581b6dc","198":"ffdbe345"}[chunkId] + ".chunk.js";
};